import { useState, useEffect } from "react";
import MetadataContext from "./metadataContext";
import { axiosInstance } from "../utils/axios";

export default function MetadataProvider({ children }) {
  const [title, setTitle] = useState(document.title);
  const [favicon, setFavicon] = useState(document.querySelector("link[rel='icon']")?.href || "");

  const [metadata, setMetadataState] = useState({
    heroText: "This is fallback hero text",
    showBetaTag: false,
    domainText: "",
    tabs: [],
    resultsFields2: {},
    sortby: [],
    filters: {}, // dynamic (updated after search)
  });

  const [isLoading, setIsLoading] = useState(true);

  const setMetadata = (newMetadata) => {
    if (!newMetadata) return;

    const { title: newTitle, favicon: newFavicon, ...rest } = newMetadata;

    if (newTitle) setTitle(newTitle);
    if (newFavicon) setFavicon(newFavicon);

    setMetadataState((prev) => ({ ...prev, ...rest }));
  };

  // Fetch static metadata (title, hero text, tabs, etc.)
  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        const res = await axiosInstance.get("/search/metadata");

        const site = res.data?.data?.metadata?.site_config || {};
        const facets = res.data?.data?.metadata?.facets || [];
        const filters = res.data?.data?.metadata?.filters || [];
        const resultsFields2 = res.data?.data?.metadata?.results_fields || {};
        const sortby = res.data?.data?.metadata?.sortby || [];

        // Title & favicon
        setTitle(site.title_text || document.title);
        setFavicon(site.fav_icon_url || favicon);

        // Tabs
        const tabs = [];
        [...facets, ...filters].forEach((item) =>
          Object.values(item).forEach((val) => tabs.push(val))
        );

        setMetadataState({
          heroText: site.hero_text || "This is fallback hero text",
          showBetaTag: site.beta_tag,
          domainText: site.domain_text,
          tabs,
          resultsFields2,
          sortby,
          filters: {}, // search will override
        });
      } catch (err) {
        console.error("Failed loading metadata", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMetadata();
  }, []);

  useEffect(() => {
    if (title) document.title = title;
  }, [title]);

  useEffect(() => {
    if (favicon) {
      let link = document.querySelector("link[rel='icon']") || document.createElement("link");
      link.rel = "icon";
      link.href = favicon;
      document.head.appendChild(link);
    }
  }, [favicon]);

  return (
    <MetadataContext.Provider value={{ metadata, setMetadata, title, favicon, isLoading }}>
      {children}
    </MetadataContext.Provider>
  );
}
